import { RouteRecordRawArgumented } from 'src/types/route'
import useI18n from 'src/hooks/i18n'

const { t } = useI18n()

const module: RouteRecordRawArgumented = {
  path: 'cat-ia',
  name: 'catIa',
  redirect: () => ({ name: 'catIaIndex' }),
  meta: {
    auth: {
      permission: 'test_cat-ia',
    },
  },
  children: [
    {
      path: '',
      name: 'catIaIndex',
      component: () =>
        import(
          /* webpackChunkName: "cat-ia-index" */ 'pages/cat-ia/IndexPage.vue'
        ),
      meta: {
        breadcrumb: {
          name: t('breadcrumb.cat_ia.index'),
          icon: 'mdi-robot-outline',
        },
        auth: {
          permission: 'test_cat-ia',
        },
      },
    },
  ],
}

export default module
